import { useContext } from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ReactComponent as CloseIcon } from 'assets/close-icon.svg';
import { MAX_NEW_TARIFF_GROUP_NAME_LENGTH } from 'components/constants';
import i18nContext from 'components/i18n-context';
import { hasRole, TARIFF_GROUPS_UPDATE } from 'services/roles';
import Button from 'uikit/Button/Button';
import Input from 'uikit/Input/Input';
import './PopUpRenameTariffGroupScheme.scss';

const PopUpRenameTariffGroupScheme = ({ isLoading, tariffGroupId, handleClose, handleRenameTariffGroup }) => {
  const i18n = useContext(i18nContext);

  const form = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      newTariffGroupName: tariffGroupId
    },
    validationSchema: Yup.object().shape({
      newTariffGroupName: Yup.string()
        .required(i18n.getMessage('renameTariffGroup.modal.validation.isRequired'))
        .max(
          MAX_NEW_TARIFF_GROUP_NAME_LENGTH,
          i18n.getMessage('renameTariffGroup.modal.validation.maxSize"', { size: MAX_NEW_TARIFF_GROUP_NAME_LENGTH })
        )
    }),
    onSubmit: async (values) => {
      await handleRenameTariffGroup(tariffGroupId, { tariffGroupId: values.newTariffGroupName });
    }
  });

  const { values, handleSubmit, errors, handleChange } = form;

  return (
    <div className={'scheme-wrapper scheme-rename-tariff-group-container'}>
      <div className={'scheme-rename-tariff-group-container-header'}>
        <h3>{i18n.getMessage('renameTariffGroup.modal.title')}</h3>
        <CloseIcon className={'scheme-rename-tariff-group-container-header-close-icon'} onClick={handleClose} />
      </div>
      <form className={'scheme-rename-tariff-group-form'} onSubmit={handleSubmit}>
        <div className={'scheme-rename-tariff-group-form-inputs-wrapper'}>
          <Input
            className={'scheme-rename-tariff-group-input'}
            id={'newTariffGroupName'}
            name={'newTariffGroupName'}
            label={i18n.getMessage('renameTariffGroup.modal.input.newTariffGroupName')}
            value={values.newTariffGroupName}
            onChange={handleChange}
            max={MAX_NEW_TARIFF_GROUP_NAME_LENGTH}
            isDisabled={!hasRole(TARIFF_GROUPS_UPDATE)}
            error={errors?.newTariffGroupName}
          />
        </div>

        <div className={'scheme-rename-tariff-group-actions-wrapper'}>
          <Button
            className={'scheme-rename-tariff-group-button'}
            type={'outline'}
            onClick={handleClose}
            isDisabled={isLoading}
          >
            {i18n.getMessage('renameTariffGroup.modal.button.cancel')}
          </Button>
          <Button
            className={'scheme-rename-tariff-group-button'}
            roleType={'submit'}
            type={'primary'}
            isDisabled={isLoading}
          >
            {i18n.getMessage('renameTariffGroup.modal.button.rename')}
          </Button>
        </div>
      </form>
    </div>
  );
};

PopUpRenameTariffGroupScheme.propTypes = {
  isLoading: PropTypes.bool,
  tariffGroupId: PropTypes.string,
  handleClose: PropTypes.func,
  handleRenameTariffGroup: PropTypes.func
};

export default PopUpRenameTariffGroupScheme;
